// ---------------------------------------------------------------------------
// InterAct Globally — link + route + brand configuration.
// Single source of truth for CTA destinations and social profiles.
// ---------------------------------------------------------------------------

export const ROUTES = {
  home: "/",
  executiveCoaching: "/executive-coaching",
  highStakesPresentationCoaching:
    "/executive-coaching/high-stakes-presentation-coaching",
  executivePresenceDevelopment:
    "/executive-coaching/executive-presence-development",
  corporateTraining: "/corporate-training",
  presentationExcellence: "/corporate-training/presentation-excellence",
  executivePresenceForLeaders: "/corporate-training/executive-presence-for-leaders",
  customPrograms: "/corporate-training/custom-programs",
  ldPartnerships: "/ld-partnerships",
  insights: "/insights",
  diagnostics: "/insights/diagnostics",
  presentationReadinessDiagnostic:
    "/insights/diagnostics/presentation-readiness",
  nextPresentationReadinessCheck:
    "/insights/diagnostics/next-presentation-readiness-check",
  executivePresenceCommunicationDiagnostic:
    "/insights/diagnostics/executive-presence-communication-diagnostic",
  presenterArchetype: "/insights/diagnostics/presenter-archetype",
  highStakesAudit: "/insights/diagnostics/high-stakes-audit",
  highStakesAuditExplainer: "/insights/free-presentation-assessment",
  articles: "/insights/articles",
  caseStudies: "/insights/case-studies",
  guides: "/insights/guides",
  presenterPlaybookGuide: "/insights/guides/next-presentation-playbook",
  tools: "/insights/tools",
  workplaceCommunicationResearch: "/resources/workplace-communication-research",
  about: "/about",
  booking: "/book",
  bookPresentation: "/book/presentation",
  bookExecutivePresence: "/book/executive-presence",
  bookCorporate: "/book/corporate",
  bookLdPartnership: "/book/ld-partnership",
  contact: "/contact",
  privacy: "/privacy",
  terms: "/terms",
};

// LINKS are the CTA destinations used across the site.
// The three legacy WordPress URLs (bookCall / diagnostic / process) are still
// referenced by some existing landing sections — they now resolve to the new
// internal routes (React Router handles the redirect).
export const LINKS = {
  bookCall: ROUTES.booking,
  diagnostic: ROUTES.nextPresentationReadinessCheck,
  epDiagnostic: ROUTES.executivePresenceCommunicationDiagnostic,
  process: ROUTES.about,
  contact: ROUTES.contact,
  email: "mailto:christos@interactglobally.com.br",
};

export const BRAND = {
  coach: "Christos Dionysopoulos",
  company: "InterAct Globally",
  tagline: "Great ideas deserve great delivery.",
  foundedYear: 2025,
  emailAddress: "christos@interactglobally.com.br",
};

export const SOCIAL = {
  linkedin: "https://www.linkedin.com/in/christosdionysopoulos",
  instagram: "https://www.instagram.com/taras_dio/",
  facebook: "https://www.facebook.com/christos.dionysopoulos.230295",
  whatsapp: "https://wa.me/5511916429735",
  whatsappNumber: "+55 11 91642-9735",
};
